const T = "yyyy-MM-dd", A = "dd-MM-yyyy", _ = "yyyy-MM", y = "-", D = 4500, E = 108;
export {
  T as DEFAULT_DATE_FORMAT,
  y as DEFAULT_INVALID_TEXT,
  A as DEFAULT_PRINT_DATE_FORMAT,
  D as DURATION_DEFAULT_ALERT_DISMISS,
  _ as KEY_DATE_FORMAT,
  E as WIDTH_DEFAULT_TABLE_COLUMN
};
